module.exports = __webpack_public_path__ + "static/5-5daea7d9fa16cf453c08c08bf3de0c60.jpeg";